import React from 'react';
import { bonusValueStack } from '../data/bonuses';
import { bonusStackTotal } from '../data/copy';
export function BonusValueSection() {
  return <section className="defer-paint w-full bg-sand py-10 sm:py-12" aria-labelledby="bonus-value-heading" data-id="element-32" data-mp="igwmx3ir8u0j">
      <div className="mx-auto max-w-2xl px-6" data-id="element-33" data-mp="4m40rm8d0fkz">
        <div className="rounded-4xl border border-line bg-shell px-7 py-9 sm:px-10" data-id="element-34" data-mp="9miad8plzxl4">
          <div className="text-center" data-id="element-35" data-mp="xd5m652nb7cy">
            <p className="eyebrow text-gold-ink" data-id="element-36" data-mp="xe750vpwky58">The bonus stack</p>
            <h2 id="bonus-value-heading" className="mt-4 font-display text-[1.75rem] leading-[1.15] text-ink sm:text-[2rem]" data-id="element-37" data-mp="11ezffsaih933">
              Total bonus value if purchased separately
            </h2>
          </div>

          <dl className="mt-8 divide-y divide-line border-y border-line" data-id="element-38" data-mp="scqadhy0i7x3">
            {bonusValueStack.map(item => <div key={item.label} className="flex items-baseline justify-between gap-6 py-3.5" data-id="element-39" data-mp="383w2hscasdwd">
                <dt className="font-sans text-[0.9rem] text-ink/85" data-id="element-40" data-mp="3d51vzsds856y">
                  {item.label}
                </dt>
                <dd className="font-display text-base text-stone" data-id="element-41" data-mp="wl9ci8q2jcpz">
                  {item.value}
                </dd>
              </div>)}
          </dl>

          <div className="mt-7 rounded-3xl bg-gold-soft/50 px-6 py-6 text-center" data-id="element-42" data-mp="16jot3hrgz3l8">
            <p className="font-sans text-[0.85rem] leading-relaxed text-gold-ink" data-id="element-43" data-mp="11kc68x0llwin">
              If purchased separately, the bonuses alone would cost
            </p>
            <p className="mt-1 font-display text-[2.75rem] leading-none text-ink" data-id="element-44" data-mp="1fi0odx3a6pk0">
              {bonusStackTotal}
            </p>
            <p className="mt-2 font-sans text-xs uppercase tracking-[0.16em] text-stone" data-id="element-45" data-mp="1p9djqyoafxus">
              Included today at no extra cost
            </p>
          </div>
        </div>
      </div>
    </section>;
}